const INITIAL_STATE = {
    resourceItems: [],
    allResources: [],
    count: 0,
    resourceItem: {},
    loading: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GET_RESOURCE_ITEMS": {
            return {
                ...state,
                resourceItems: action.data,
                count: action.count,
                loading: false
            }
        }
        case "GET_RESOURCE_ITEM": {
            return {
                ...state,
                resourceItem: action.data,
                loading: false
            }
        }
        case "GET_ALL_RESOURCE": {
            return {
                ...state,
                allResources: action.data,
                loading: false
            }
        }


        default:
            return state
    }
}
